import { ColumnModel } from '@syncfusion/ej2-react-grids'

export const TX_PLAN_INSURANCE_ESTIMATE_COLUMN_FIELDS = new Set([
  'allowed_amt',
  'write_off',
  'insurance',
  'outstanding',
])

export const filterTxPlanInsuranceEstimateColumns = (
  columns: ColumnModel[],
  showInsuranceEstimate: boolean,
): ColumnModel[] => {
  if (showInsuranceEstimate) {
    return columns
  }
  return columns.filter(
    (column) =>
      !column.field ||
      !TX_PLAN_INSURANCE_ESTIMATE_COLUMN_FIELDS.has(column.field),
  )
}
